// removed by extract-text-webpack-plugin
module.exports = {"Banner":"_1YsP4b_9","Card":"_3ftpIGEu","BannerIcon":"_1mivkS6I","TextSection":"b1FZVpt4","LinkButton":"lU2lL1Qv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cards/banner-card/banner-card-component.styles.scss
// module id = 228
// module chunks = 0